import { render, staticRenderFns } from "./UserPageDesign.vue?vue&type=template&id=30e5ffbb&scoped=true&"
import script from "./UserPageDesign.vue?vue&type=script&lang=js&"
export * from "./UserPageDesign.vue?vue&type=script&lang=js&"
import style0 from "./UserPageDesign.vue?vue&type=style&index=0&id=30e5ffbb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e5ffbb",
  null
  
)

export default component.exports